export const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};

export const isMicrosoft = {
  InternetExplorer: function () {
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    return (
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1
    );
  },
  Edge: function () {
    return navigator.userAgent.indexOf("Edge") > -1;
  },
  any: function () {
    return isMicrosoft.InternetExplorer() || isMicrosoft.Edge();
  },
};

export const isChromeAndroid = {
  AndroidPhone: function () {
    var ua = navigator.userAgent;
    var android = !!ua.match(/Android/i);
    var chrome = !!ua.match(/Chrome\/[.0-9]* Mobile/i);
    return android && chrome;
  },
  AndroidTablet: function () {
    var ua = navigator.userAgent;
    var android = !!ua.match(/Android/i);
    var chrome = !!ua.match(/Chrome}\/[.0-9]* (?!Mobile)/i);
    return android && chrome;
  },
  any: function () {
    return isChromeAndroid.AndroidPhone() || isChromeAndroid.AndroidTablet();
  },
};

export const isSafariOniOS = {
  Safari: function () {
    /*
        Returns (true/false) whether device agent is iOS Safari
    */
    var ua = navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkitUa = !!ua.match(/WebKit/i);

    return (
      typeof webkitUa !== "undefined" && iOS && webkitUa && !ua.match(/CriOS/i)
    );
  },
  any: function () {
    return isSafariOniOS.Safari();
  },
};

const CheckIf = {
  isMobile,
  isMicrosoft,
  isChromeAndroid,
  isSafariOniOS,
};

export default CheckIf;